import { Helmet } from "react-helmet";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { Route, Routes } from "react-router-dom";
import { privateRoutes, publicRoutes } from "../../Routes";

const { useUnoSelector } = UnoStoreHooks;

const Layout = ({ isMobileView }) => {
  const userData = useUnoSelector((state) => state.user);
  const configData = useUnoSelector((state) => state.config);
  const isLoggedIn = userData?.token?.length > 0 ? true : false;

  let filterPrivateRoutes = privateRoutes.filter(route => route.viewer === undefined || route.viewer === (configData?.config?.permissions?.showSideBar ?? true));

  return (
    <>
      <Helmet>
        <title> {configData?.config?.BROWSER_TITLE ?? "360"} </title>
      </Helmet>
      <Routes>
        {isLoggedIn ?
          filterPrivateRoutes.map((route) => {
            const RenderComponent = route.element;
            const LayoutComponent = route.layout;
            const showSidebar = route.showSidebar && (configData?.config?.permissions?.showSideBar ?? true);
            const showHeader = route.showHeader;
            const enableMobileView = route.enableMobileView;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <LayoutComponent
                    showSidebar={showSidebar}
                    showHeader={showHeader}
                    isMobileView={isMobileView && enableMobileView}
                  >
                    <RenderComponent isMobileView={isMobileView} />
                  </LayoutComponent>
                }
              />
            );
          })
          :
          publicRoutes.map((route) => {
            const RenderComponent = route.element;
            const LayoutComponent = route.layout;
            const showSidebar = route.showSidebar;
            const showHeader = route.showHeader;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <LayoutComponent showSidebar={showSidebar} showHeader={showHeader} isMobileView={isMobileView}>
                    <RenderComponent isMobileView={isMobileView} />
                  </LayoutComponent>
                }
              />
            );
          })}
      </Routes>
    </>
  );
};
export default Layout;
